import React from 'react';
import CountryName from '../components/CountryName';
import {Price} from '../models/event/Price';
import {IEvent} from '../models/event/Event';
import ScheduleFormatter from '../models/formatter/ScheduleFormatter';
import Schedule from '../models/event/Schedule';

export function getEventTicketTypePrice(ticketType: Price) {
  return (ticketType.currency !== null) ? `${ticketType.amount || 0} ${ticketType.currency}` : null;
}

export function getEventHint(event: IEvent) {
  return (
    <span>{getEventLocation(event)}, {formatEventDatesInterval(event)}</span>
  );
}

export function getEventLocation(event: IEvent) {
  if (event.location.online) {
    return 'online';
  }

  if (event.location.city) {
    return (<span>{event.location.city}, <CountryName code={event.location.country}/></span>);
  }

  return <CountryName code={event.location.country}/>;
}


export function formatEventDatesInterval(event: IEvent) {
  return ScheduleFormatter.format('en-GB', new Schedule(event.schedule), 'interval');
}
